import { render, staticRenderFns } from "./LoadCards.vue?vue&type=template&id=2589e8de&scoped=true"
import script from "./LoadCards.vue?vue&type=script&lang=js"
export * from "./LoadCards.vue?vue&type=script&lang=js"
import style0 from "./LoadCards.vue?vue&type=style&index=0&id=2589e8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589e8de",
  null
  
)

export default component.exports